<template>
    <academic>
        <div
            class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg h-96"
        >
            <loading :showLoading="form.processing" />
            <div
                :class="{
                    'opacity-50': form.processing,
                    'opacity-100': !form.processing,
                }"
            >
                <p class="text-lg font-medium mb-4">Edit Duration Semester</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                required
                                label="Duration"
                                :options="durations"
                                track-key="id"
                                label-key="code"
                                return-key="id"
                                v-model="form.duration_id"
                                :placeholder="'Select Duration'"
                                :error="form.errors.duration_id"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                required
                                label="Semester"
                                :options="semesters"
                                track-key="id"
                                label-key="title"
                                return-key="id"
                                v-model="form.semester_id"
                                :placeholder="'Select Semester'"
                                :error="form.errors.semester_id"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                required
                                label="Start Month"
                                :options="months"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.start_month"
                                :placeholder="'Start Month'"
                                :error="form.errors.start_month"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                required
                                label="End Month"
                                :options="months"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.end_month"
                                :placeholder="'End Month'"
                                :error="form.errors.end_month"
                            />
                        </div>
                        <div class="col-span-8">
                            <breeze-label :value="'Status'" />
                            <breeze-checkbox
                                v-model="form.status"
                                :checked="form.status"
                            />
                            <breeze-input-error
                                :message="form.errors ? form.errors.status : ''"
                            />
                        </div>
                    </div>
                    <button-link
                        :href="route('academic.durationSemester.list')"
                        class="bg-red-500 mr-4 hover:bg-red-400"
                        >Cancel</button-link
                    >
                    <breeze-button :disabled="form.processing"
                        >Save</breeze-button
                    >
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
import Academic from "@/Pages/Academic/Academic";
import BreezeTable from "@/Components/Table";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeCheckbox from "@/Components/Checkbox";
import InputCheckbox from "@/Components/InputCheckbox";
import BreezeInputError from "@/Components/InputError";
import ButtonLink from "@/Components/ButtonLink";
import SelectList from "@/Components/SelectList";
import Exception from "@/Components/Exception";
import { useForm } from "@inertiajs/inertia-vue3";
import Loading from "@/Components/Loading";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Academic,
        BreezeTable,
        ButtonLink,
        BreezeInput,
        BreezeCheckbox,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        InputCheckbox,
        Loading,
        SelectList,
    },
    props: ["durationSemester", "durations", "semesters"],
    data() {
        const months = [
            { id: 1, title: "January" },
            { id: 2, title: "February" },
            { id: 3, title: "March" },
            { id: 4, title: "April" },
            { id: 5, title: "May" },
            { id: 6, title: "June" },
            { id: 7, title: "July" },
            { id: 8, title: "August" },
            { id: 9, title: "September" },
            { id: 10, title: "October" },
            { id: 11, title: "November" },
            { id: 12, title: "December" },
        ];

        return {
            form: useForm({
                _method: "PUT",
                duration_id: this.durationSemester.duration_id,
                semester_id: this.durationSemester.semester_id,
                start_month: months.find(
                    (m) => m.title === this.durationSemester.start_month
                ),
                end_month: months.find(
                    (m) => m.title === this.durationSemester.end_month
                ),
                status: this.durationSemester.status,
            }),
            months: months,
        };
    },
    methods: {
        submitForm() {
            this.form.post(
                route(
                    "academic.durationSemester.update",
                    this.durationSemester.id
                ),
                {
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                }
            );
        },
    },
};
</script>
